
interface NotImplementedYetProps {
	info: string;
}

export const NotImplementedYet: React.FC<NotImplementedYetProps> = ({ info }) => {
		return (
			<>
			<h1><b>{info}</b></h1>
			<h2>halaman ini belum diimplementasikan</h2>
			</>
		)
}

